module.exports = __webpack_public_path__ + "static/img/about7.00fc43d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about7.png
// module id = EPRd
// module chunks = 1